export default [
  {
    value: 'GUIDE',
    title: 'Гид'
  },
  {
    value: 'TOURIST_AGENCY',
    title: 'Туристическое агенство'
  }
]
